class MediaPlayer extends HTMLElement {
  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
    this.playing = false
  }

  connectedCallback() {
    const preview = this.getAttribute('preview') || null
    const videoSrc = this.getAttribute('video-src') || null
    const width = this.getAttribute('width') ? this.getAttribute('width') + 'px' : '100%'
    const height = this.getAttribute('height') ? this.getAttribute('height') + 'px' : '100%'
    const loop = this.getAttribute('loop') || 0
    const controls = this.getAttribute('controls') || 0
    const lazy = this.getAttribute('lazy') || 0
    const caption = this.getAttribute('caption') || ''
    const caption_top = this.getAttribute('caption-top') ? this.getAttribute('caption-top') + '%' : '65%'
    const caption_top_m = this.getAttribute('caption-top-mobile') ? this.getAttribute('caption-top-mobile') + '%' : '65%'
    const caption_color = this.getAttribute('caption-color') ?? '#FFFFFF'
    const button_style = this.getAttribute('button-style') || 0
    const button_icon = `
          <svg xmlns="http://www.w3.org/2000/svg" width="114" height="114" viewBox="0 0 114 114">
            <g id="Play" transform="translate(-903 -3577)">
              <circle id="Ellipse_21" data-name="Ellipse 21" cx="57" cy="57" r="57" transform="translate(903 3577)" fill="#fff" opacity="0.6"/>
              <path id="Polygon_1" data-name="Polygon 1" d="M20.4,4.523a3,3,0,0,1,5.2,0L43.415,35.5a3,3,0,0,1-2.6,4.5H5.186a3,3,0,0,1-2.6-4.5Z" transform="translate(986 3611) rotate(90)" fill="#656565"/>
            </g>
          </svg>`

    const attrs = `
      src="${videoSrc}"
      playsinline
      ${loop ? 'loop' : ''}
      ${controls ? 'controls' : ''}
      ${lazy ? '' : 'preload="auto"'}
      ${height ? `height="${height}"` : ""}
      ${preview ? '' : 'class="playing"'}
    `;

    const previewHTML = preview ? `<img src="${preview}" width="${width}" height="${height}" loading="lazy" />` : '';
    const videoHTML = (!lazy || !preview) ? `<video ${attrs}></video>` : ''
    const captionHTML = caption ? `<div class="caption">${caption}</div>` : ''

    let playButton = `<div class="play-button"></div>`
    if(button_style == 'simple') {
      playButton = `<div class="play-button simple"></div>`
    }
    else if(button_style == 'default') {
      playButton = `<div class="play-button contain">
        ${button_icon}
      </div>`
    }
    else if(button_style == 'default_blured') {
      playButton = `<div class="play-button contain blured">
        ${button_icon}
      </div>`
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-block;
          position: relative;
          width: ${width};
          height: ${height};
          overflow: hidden;
          cursor: pointer;
        }
        .caption {
          position: absolute;
          top: ${caption_top};
          left: 50%;
          transform: translate(-50%);
          color: ${caption_color};
          font-size: 24px;
          font-weight: bold;
          font-family: 'Qartella';
          text-align: center;
        }
        .preview-container, .video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          position: relative;
          z-index: 1;
        }
        .blured {
          backdrop-filter: blur(3px);
        }
        .play-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 100px;
          height: 100px;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
          backdrop-filter: blur(2px);
        }
        .play-button.simple {
          backdrop-filter: blur(0px);
        }
        .play-button.contain {
          background: none;
        }
        .play-button.contain:before {
          content: none;
        }
        .play-button::before {
          content: '';
          width: 0;
          height: 0;
          border-left: 25px solid #000000c4;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
          margin-left: 4px;
        }
        video {
          display: none;
        }
        video.playing {
          display: block;
        }
        .video-wrapper video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .video-wrapper {
          position: absolute;
          inset: 0;
        }

        @media (max-width: 800px) {
          .caption {
            font-size: 15px;
          }
          .play-button {
            width: 75px;
            height: 75px;
          }
          .caption {
            top: ${caption_top_m};
          }
        }
        @media (max-width: 420px) {
          .play-button {
              width: 50px;
              height: 50px;
          }
        }
      </style>
      <div class="preview-container">
        ${previewHTML}
        ${playButton}
        ${captionHTML}
      </div>
      <div class="video-wrapper">
        ${videoHTML}
      </div>
      `

    this.videoAttrs = attrs;
    this.shadowRoot.querySelector('.play-button').addEventListener('click', () => this.play())
    let previewImg = this.shadowRoot.querySelector('.preview-container img, .video-wrapper video')
    if(previewImg) {
      this.shadowRoot.querySelector('.preview-container').addEventListener('click', () => this.play())
    }
    
  }

  play() {
    if(this.playing) return
    this.playing = true

    const wrapper = this.shadowRoot.querySelector('.video-wrapper')
    const preview = this.shadowRoot.querySelector('.preview-container')
    if(!wrapper.querySelector('video')) {
      wrapper.innerHTML = `<video ${this.videoAttrs}></video>`
    }

    const video = wrapper.querySelector('video')
    preview.remove()
    video.classList.add('playing')
    video.play()
  }
}

customElements.define('media-player', MediaPlayer);